import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useSnackbar } from "notistack";

import extededFormStyles from "../../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import CardHeader from "../../../components/Card/CardHeader";
import CardText from "../../../components/Card/CardText";
import ClientSearchComponent from "../../../components/ClientSearch";
import Button from "../../../components/CustomButtons/Button";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import { isEmpty } from "../../../utils/barrels/lodash";
import {
	Dialog,
	DialogActions,
	DialogContent,
	makeStyles,
} from "../../../utils/barrels/material-ui-core";
import { readCookie } from "../../../utils/functions";

import DragDrop from "./DragDrop";
import RbSelect from "./RbSelect";
import tickmarkIcon from "./tickmark.png";

const styles = {
	extededFormStyles,
	cardCategoryWhite: {
		color: "rgba(255,255,255,.62)",
		margin: "0",
		fontSize: "14px",
		marginTop: "0",
		marginBottom: "0",
	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "inherit",
		marginBottom: "3px",
		textDecoration: "none",
	},
	alignCenter: {
		textAlign: "center",
	},
	custom_card: {
		minHeight: "180px",
	},
	deliveryPartner: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
	},
	dpImage: {
		width: "48px",
		height: "48px",
		marginRight: "16px",
		borderRadius: "4px",
	},
	selectRule: {
		margin: "25px auto",
	},
	selectCardBorder: {
		border: "2px solid #6F57E9",
	},
	dradDropCard: {
		height: "200px",
		width: "250px",
		margin: "10px auto",
	},
	selectCard: {
		padding: "15px",
		paddingBottom: "25px",
		boxShadow: "4px 6px 10px 0 rgba(209,209,209,1)",
	},
};

const useStyles = makeStyles(styles);

const selectCardsData = [
	{
		id: 1,
		name: "none",
		img: "/assets/img/none_rule.svg",
		message: "auto_assign_carrier_is_disabled",
	},
	{
		id: 2,
		name: "cheapest",
		img: "/assets/img/cheapest_carrier_rule.webp",
		value: "cheapest_first",
		message: "carrier_will_be_assigned_based_on_cheapest_cost",
	},
	{
		id: 3,
		name: "custom",
		value: "custom",
		img: "/assets/img/custom.webp",
		message: "carrier_will_be_assigned_based_on_you_set_priority",
	},
	{
		id: 4,
		name: "SmartShip Priority Engine",
		value: "rocketbox_select",
		img: "/assets/img/custom.webp",
		message: "carrier_will_be_assigned_based_on_you_set_priority",
	},
];

export default function SetRules(props) {
	const classes = useStyles();
	const [autoAssignData, setAutoAssignData] = useState({});
	const [client, setClient] = useState({});
	const [modes, setModes] = useState([]);
	const [clientValue, setClientValue] = useState({});
	const [isStaff, setIsStaff] = useState(false);
	const [rules_data, setRulesData] = useState([]);
	const [open, setOpen] = useState(false);
	const { enqueueSnackbar } = useSnackbar();

	const [selectedCard, setSelectedCard] = useState(0);
	const [partiallyselectedCard, setPartiallySelectedCard] = useState(0);
	const [edit, setEdit] = useState(false);
	const [item, setItem] = useState([]);
	const [partialCardValue, setPartialCardValue] = useState();

	const { t } = useTranslation();

	const selectCard = (val) => {
		setPartialCardValue(val);
		if (selectedCard === 2 && edit) {
			setOpen(true);
		} else {
			setPartiallySelectedCard(val);
		}
	};

	const prepareBodyData = (rule, allModes) => {
		const data = {};
		if (isStaff) {
			data.client_id = clientValue.id;
		} else if (client?.client_poc?.client?.id) {
			data.client_id = client?.client_poc?.client?.id;
		} else {
			data.client_id = localStorage.getItem("client_id");
		}
		data.rule_type = rule;
		data.carriers_list = allModes ? allModes : {};
		return data;
	};

	const fetchAutoAssignCarriers = () => {
		props.setBackdrop(true);
		props.getAutoAssignCarrier(clientValue.id).then((data) => {
			if (data.length !== 0) {
				setAutoAssignData(data[0]);
				data[0]?.carriers_list.length !== 0 && setModes(data[0].carriers_list);
				if (data[0].rule_type === "custom" && data[0].is_active) {
					setSelectedCard(2);
					setPartiallySelectedCard(2);
				} else if (
					data[0].rule_type === "rocketbox_select" &&
					data[0].is_active
				) {
					setSelectedCard(3);
					setPartiallySelectedCard(3);

					setRulesData(data[0].rb_select_rules);
					props.setCarrierSettingId(data[0].id ? data[0].id : 0);
					props.setRulePriority(data[0].rb_select_rules.length + 1);
				} else if (
					data[0].rule_type === "cheapest_first" &&
					data[0].is_active
				) {
					setSelectedCard(1);
					setPartiallySelectedCard(1);
				}
			} else {
				setSelectedCard(0);
				setPartiallySelectedCard(0);
			}
			props.setBackdrop(false);
		});
	};

	const updateAutoAssignRule = (allModes, val = selectedCard, is_active) => {
		props.setBackdrop(true);
		const data = prepareBodyData(selectCardsData[val].value, allModes);
		data.is_active = is_active;
		props.updateAutoAssignCarrier(data, autoAssignData.id).then(() => {
			fetchAutoAssignCarriers();
			props.setBackdrop(false);
			enqueueSnackbar("Success", {
				variant: "success",
				autoHideDuration: 500,
			});
			props.closeModel && val === 1 && props.closeModel();
			props.closeModel && val === 2 && props.showCloseButton(true);
		});
	};

	const changeSelected = (val) => {
		if (isStaff && Object.keys(clientValue).length === 0) {
			enqueueSnackbar("Please select Client", {
				variant: "error",
				autoHideDuration: 5000,
			});
			return;
		}
		if (selectedCard === val) {
			return;
		}
		if (selectedCard !== 0 && val === 0) {
			updateAutoAssignRule(modes, selectedCard, false);
		} else if (selectedCard === 0 && val !== 0 && !autoAssignData.id) {
			props.setBackdrop(true);
			const data = prepareBodyData(selectCardsData[val].value, modes);
			props.createAutoAssignCarrier(data).then(() => {
				fetchAutoAssignCarriers();
				props.setBackdrop(false);
				enqueueSnackbar("Success", {
					variant: "success",
					autoHideDuration: 500,
				});
				props.closeModel && val === 1 && props.closeModel();
				props.closeModel && val === 2 && props.showCloseButton(true);
			});
		} else {
			updateAutoAssignRule(modes, val, true);
		}
		setSelectedCard(val);
	};

	useEffect(() => {
		const bearerToken = readCookie("bearer");
		fetchAutoAssignCarriers();
		props.getAllModeLists().then((data) => {
			props.setBackdrop(true);
			setModes(data);
			props.setBackdrop(false);
		});
		if (bearerToken) {
			const clientData = readCookie("client", true);
			if (clientData) {
				setClient(clientData);
				setIsStaff(clientData?.is_staff);
				fetchAutoAssignCarriers();
				props.getAllModeLists().then((data) => {
					props.setBackdrop(true);
					setModes(data);
					props.setBackdrop(false);
				});
			}
		} else {
			props.setUser({ reAuth: true, showReAuthModal: true });
		}
		window.addEventListener("popstate", (e) => {
			e.preventDefault();
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const setClientID = (event, val) => {
		if (!isEmpty(val)) {
			setClientValue(val);
		} else {
			setClientValue({});
		}
	};

	useEffect(() => {
		if (clientValue.length !== 0) {
			fetchAutoAssignCarriers();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [clientValue]);

	const saveCarrierList = () => {
		if (edit) {
			updateAutoAssignRule(item);
			setEdit(false);
			setOpen(false);
		} else {
			enqueueSnackbar("No Changes Detected", {
				variant: "warning",
				autoHideDuration: 1500,
			});
		}
	};
	const closeModal = () => {
		setOpen(false);
		setEdit(false);
		setPartiallySelectedCard(partialCardValue);
	};

	return (
		<div>
			<GridContainer spacing={2}>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardHeader color="primary" text>
							<CardText color="primary">
								<h4 className={classes.cardTitle}>{t("set_carrier_rules")}</h4>
							</CardText>
						</CardHeader>
						<CardBody>
							{isStaff && (
								<GridContainer>
									<GridItem xs={8} sm={8} md={8} />

									<GridItem xs={4} sm={4} md={4}>
										<ClientSearchComponent
											value={clientValue}
											onChange={setClientID}
											showClient_id
											// isStaff={isStaff}
										/>
									</GridItem>
								</GridContainer>
							)}
							<GridItem xs={12} sm={12} md={12}>
								<GridContainer>
									{selectCardsData.map((cardItem, i) => (
										<GridItem
											xs={3}
											sm={3}
											md={3}
											key={`card-${cardItem?.id}-${i + 1}`}
											onClick={() => selectCard(i)}
											className={classes.alignCenter}
										>
											<Card
												className={`${
													partiallyselectedCard === i &&
													classes.selectCardBorder
												} ${classes.selectCard} ${classes.custom_card}`}
											>
												{selectedCard === i && (
													<img
														src={tickmarkIcon}
														style={{ "align-self": "self-end" }}
														alt="Selected"
													/>
												)}
												<div className={classes.alignCenter}>
													<img
														src={cardItem.img}
														width="50"
														alt={cardItem.name || "Rule icon"}
													/>
												</div>

												<h5>{t(cardItem.name)}</h5>
												<span>{t(cardItem.message)}</span>
											</Card>
										</GridItem>
									))}
								</GridContainer>
							</GridItem>
							{selectedCard !== partiallyselectedCard && (
								<Button
									onClick={() => changeSelected(partiallyselectedCard)}
									style={{ float: "right" }}
									color="primary"
								>
									Select
								</Button>
							)}
							{selectedCard === 2 && partiallyselectedCard === 2 ? (
								<>
									<GridItem
										sm={10}
										md={10}
										xs={10}
										className={classes.selectRule}
									>
										<DragDrop
											data={modes}
											updateAutoAssignRule={updateAutoAssignRule}
											edit={edit}
											setEdit={(bool) => setEdit(bool)}
											itemData={item}
											setitemData={(data) => {
												setItem(data);
											}}
										/>
									</GridItem>
									<GridItem
										sm={10}
										md={10}
										xs={10}
										className={classes.selectRule}
									>
										<span style={{ float: "left" }}>
											Note : Prioritization order is left to right.
										</span>
										<Button
											style={{ float: "right" }}
											onClick={() => {
												saveCarrierList();
											}}
											color="primary"
										>
											Save
										</Button>
									</GridItem>
								</>
							) : (
								selectedCard === 3 && (
									<GridItem
										sm={12}
										md={12}
										xs={12}
										className={classes.selectRule}
									>
										<RbSelect {...props} rules_data={rules_data} />
									</GridItem>
								)
							)}
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
			<Dialog
				onClose={() => setOpen(false)}
				aria-labelledby="customized-dialog-title"
				open={open}
				fullWidth
			>
				<DialogContent dividers>
					<p>You have unsaved changes in courier prioritization.</p>
				</DialogContent>
				<DialogActions>
					<Button color="primary" onClick={() => closeModal()}>
						Close
					</Button>
					<Button
						color="primary"
						onClick={() => {
							saveCarrierList();
						}}
					>
						Save changes
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
